import { createSlice } from '@reduxjs/toolkit';
import { cancelWarehouseSendFromStock, warehouseReceptionGuide } from '../guide/thunk';
import { warehouseSendFromStock } from '../guideDetail/thunk';
import {
	addNewResidueIntake,
	updateResidueIntake,
	deleteResidueIntake,
} from '../residueIntake/thunk';
import { getWarehouseResidueStock } from './thunk';

export const initialState = {
	stockList: [],
	isLoadingList: false,
	error: null,
	/** Incremented when ledger/stock changes elsewhere; mounted views refetch. */
	stockMutationEpoch: 0,
};

function bumpStockMutationEpoch(state) {
	state.stockMutationEpoch += 1;
	state.stockList = [];
	state.error = null;
}

const WarehouseResidueStockSlice = createSlice({
	name: 'WarehouseResidueStock',
	initialState,
	reducers: {
		clearWarehouseResidueStock(state) {
			state.stockList = [];
			state.error = null;
		},
	},
	extraReducers: builder => {
		builder
			.addCase(getWarehouseResidueStock.pending, state => {
				state.isLoadingList = true;
				state.error = null;
			})
			.addCase(getWarehouseResidueStock.fulfilled, (state, action) => {
				state.stockList = Array.isArray(action.payload) ? action.payload : [];
				state.isLoadingList = false;
			})
			.addCase(getWarehouseResidueStock.rejected, (state, action) => {
				state.isLoadingList = false;
				state.error = action.payload || action.error?.message || null;
			})
			// Refetch triggers for RESPEL stock consumers (listado + picker generador)
			.addCase(warehouseSendFromStock.fulfilled, bumpStockMutationEpoch)
			.addCase(cancelWarehouseSendFromStock.fulfilled, bumpStockMutationEpoch)
			.addCase(warehouseReceptionGuide.fulfilled, bumpStockMutationEpoch)
			.addCase(addNewResidueIntake.fulfilled, bumpStockMutationEpoch)
			.addCase(updateResidueIntake.fulfilled, bumpStockMutationEpoch)
			.addCase(deleteResidueIntake.fulfilled, bumpStockMutationEpoch);
	},
});

export const { clearWarehouseResidueStock } =
	WarehouseResidueStockSlice.actions;

export default WarehouseResidueStockSlice.reducer;
